(function($) {

  function trackLayoutSizes() {
    const builder = $('#product-builder')
    const builderParent = builder.closest('.shopify-app-block')
    const headerDesktop = $('.page__header--desktop')
    const headerMobile = $('.page__header--mobile')
    const previewContainer = $('.cpb-preview-container')

    new ResizeObserver(function() {
      addCssVariable(builderParent, '--header-d-height', headerDesktop.height() + 'px')
    }).observe(headerDesktop[0])
    addCssVariable(builderParent, '--header-d-height', headerDesktop.height() + 'px')

    new ResizeObserver(function() {
      addCssVariable(builderParent, '--header-m-height', headerMobile.height() + 'px')
    }).observe(headerMobile[0])
    addCssVariable(builderParent, '--header-m-height', headerMobile.height() + 'px')

    new ResizeObserver(function() {
      addCssVariable(builderParent, '--preview-container-width', previewContainer.width() + 'px')
    }).observe(previewContainer[0])
    addCssVariable(builderParent, '--preview-container-width', previewContainer.width() + 'px')
  }

  function addCssVariable($element, variableName, variableValue) {
    let styleText = $element.attr('style') || ''
    if(styleText.includes(variableName) === false) {
      styleText += `${variableName}:${variableValue}; `
    } else {
      const regexp = new RegExp(`${variableName}[^;]+;`)
      styleText = styleText.replace(regexp, `${variableName}:${variableValue};`)
    }
    $element.attr('style', styleText)
  }

  
  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function() {
    trackLayoutSizes()
  })
})(jQuery)